import React from 'react';
import { FormatListBulleted, RecordVoiceOver } from '@mui/icons-material';
import DehazeRoundedIcon from '@mui/icons-material/DehazeRounded';
import { useTranslation } from 'react-i18next';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import CreditsIcon from '@src/assets/icons/credits-icon.svg';
import useTotalCredits from '@src/hooks/useTotalCredits';
import { StyledUsageStats } from './index.style';
import StatCard from './StatCard';

const continueButtonStyle = {
  width: '156px',
  height: '48px',
  background: COLOR.yellow.default,
  borderRadius: '12px',
  fontSize: '16px',
  fontWeight: 600,
  color: COLOR.darkBlue,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  boxShadow: 'none',
  '&:hover': { background: COLOR.yellow.default, boxShadow: 'none' },
};

const UsageStats = ({ usageStats, onContinue }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const { totalCredits: remainingCredits } = useTotalCredits();

  const { tts = {}, voiceCloning = {} } = usageStats || {};

  const formatNumber = (value) => (value ?? 0).toLocaleString(language);

  const cards = [
    {
      icon: <FormatListBulleted sx={{ fontSize: 24, color: COLOR.darkBlue }} />,
      label: t('statTotalRequests'),
      value: formatNumber(tts?.totalRequests),
    },
    {
      icon: <DehazeRoundedIcon sx={{ fontSize: 24, color: COLOR.darkBlue }} />,
      label: t('statCreditsUsed'),
      value: formatNumber(tts?.totalCredits),
    },
    {
      icon: <RecordVoiceOver sx={{ fontSize: 24, color: COLOR.darkBlue }} />,
      label: t('statTotalClonedVoices'),
      value: formatNumber(voiceCloning?.totalVoices),
    },
    {
      icon: (
        <img
          src={CreditsIcon}
          alt="credits"
          style={{ width: '24px', height: '24px' }}
        />
      ),
      label: t('statCreditsRemaining'),
      value: formatNumber(remainingCredits),
    },
  ];

  return (
    <StyledUsageStats>
      <h2 className="stats-title">{t('usageStatsTitle')}</h2>
      <p className="stats-description">{t('usageStatsDescription')}</p>
      <div className="stats-grid">
        {cards.map(({ icon, label, value }) => (
          <StatCard key={label} icon={icon} label={label} value={value} />
        ))}
      </div>
      <div className="cta-row">
        <CommonButton
          variant="contained"
          onClick={onContinue}
          customStyle={continueButtonStyle}
        >
          {t('continueButton')}
        </CommonButton>
      </div>
    </StyledUsageStats>
  );
};

export default UsageStats;
